import { profilePics } from "utils/ProfilePics";

interface AvatarSource {
  photo?: string | null;
  profilePicIndex?: string | number | null;
}

/**
 * The picture for a signed-in admin: an uploaded photo, else the chosen stock photo, else
 * undefined so the Avatar shows initials. The top bar and the profile page both use this.
 */
export const avatarSrc = (user: AvatarSource | null | undefined): string | undefined => {
  if (!user) {
    return undefined;
  }
  if (user.photo) {
    return user.photo;
  }
  if (
    user.profilePicIndex === null ||
    user.profilePicIndex === undefined ||
    user.profilePicIndex === ""
  ) {
    return undefined;
  }
  const index = Number(user.profilePicIndex);
  return Number.isInteger(index) ? profilePics[index] : undefined;
};
